import {format} from 'date-fns';

const formattedDate = (date: string) => {
  if (date != null) {
    return format(Date.parse(date), 'dd/MM yyyy');
  } else {
    return null;
  }
};

export default formattedDate;
